/* AIVIQ Aspire pages: »Find din Aspire« (quiz) and the comparison (#sammenlign).
   Data: snippets/aiviq-pdp-aspire-finder.liquid (copy + live prices). Rules: pdp/aspire-family-spec.md §7 (quiz) and §8
   (comparison). Layout: the Aspire boards. Computers from 1200 px show four cards; smaller screens two models side by side. */
(function () {
  const host = document.querySelector('[data-apf]');
  const cmp = document.querySelector('[data-apf-cmp]');
  if (!host || host.dataset.apfReady) return;
  host.dataset.apfReady = '1';

  let C, L;
  try {
    C = JSON.parse(host.querySelector('[data-apf-copy]').textContent);
    L = JSON.parse(host.querySelector('[data-apf-live]').textContent);
  } catch (e) { return; }

  const NB = ' ';
  const models = C.order
    .map((key, rung) => Object.assign({ key, rung }, C.models[key], L.models[key] || {}))
    .filter((m) => m.ok);
  if (models.length < 2) { host.hidden = true; if (cmp) cmp.hidden = true; return; }
  const by = (key) => models.find((m) => m.key === key);
  const cur = models.find((m) => m.handle === L.current) || null;
  const pool = models.filter((m) => m.available);
  const money = (cents) => new Intl.NumberFormat('da-DK').format(Math.round(cents / 100)) + NB + 'kr';
  const fill = (s, o) => s.replace(/\{(\w+)\}/g, (m, k) => (k in o ? o[k] : m));
  const body = host.querySelector('[data-apf-body]');
  const form = document.querySelector('[data-ap-form]');
  const mainAdd = form && form.querySelector('[data-ap-add]');
  const canAdd = !!(form && mainAdd && !mainAdd.disabled);

  /* small DOM helper: el('p.cls', {attr}, child | [children]) */
  function el(sel, attrs, kids) {
    const parts = sel.split('.');
    const n = document.createElement(parts[0]);
    if (parts.length > 1) n.className = parts.slice(1).join(' ');
    if (attrs) Object.keys(attrs).forEach((k) => { if (attrs[k] !== false && attrs[k] != null) n.setAttribute(k, attrs[k] === true ? '' : attrs[k]); });
    [].concat(kids == null ? [] : kids).forEach((k) => { if (k != null && k !== false) n.append(k); });
    return n;
  }
  const CHECK = () => {
    const s = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    s.setAttribute('viewBox', '0 0 24 24'); s.setAttribute('fill', 'none'); s.setAttribute('stroke', 'currentColor');
    s.setAttribute('stroke-width', '2'); s.setAttribute('aria-hidden', 'true'); s.setAttribute('class', 'apf-check');
    const p = document.createElementNS('http://www.w3.org/2000/svg', 'path'); p.setAttribute('d', 'm5 12.5 4.2 4L19 7'); s.append(p);
    return s;
  };

  /* ---------- quiz: questions, budget caps, scoring ---------- */
  const caps = [...new Set(pool.map((m) => Math.ceil(m.price / 100000) * 100000))].sort((a, b) => a - b);
  caps.pop(); /* the top rung is »Uden grænse« */
  const questions = C.questions.map((q) => Object.assign({}, q));
  questions[3].options = caps.map((c) => ({ v: String(c), label: fill(C.ui.capLabel, { cap: money(c) }) })).concat([{ v: 'any', label: C.ui.any }]);

  const KEY = 'aiviq-finder-aspire';
  let answers = [null, null, null, null]; /* a value, or 'skip' */
  let step = 0;
  let result = null;
  try {
    const saved = JSON.parse(localStorage.getItem(KEY) || 'null');
    if (saved && Array.isArray(saved.a) && saved.a.length === 4 && saved.a.every((v, i) => v === 'skip' || questions[i].options.some((o) => o.v === v))) {
      answers = saved.a; step = 4;
    }
  } catch (e) { /* no storage: the quiz still works */ }
  const save = () => { try { if (step === 4) localStorage.setItem(KEY, JSON.stringify({ a: answers })); else localStorage.removeItem(KEY); } catch (e) { /* ignore */ } };

  function compute() {
    const pts = (m, v) => ((C.fit[v] || {})[m.key] || 0);
    const given = answers.slice(0, 3).filter((v) => v && v !== 'skip');
    const score = (m) => given.reduce((s, v) => s + pts(m, v), 0);
    const cap = answers[3] && answers[3] !== 'skip' && answers[3] !== 'any' ? Number(answers[3]) : 0;
    let under = cap ? pool.filter((m) => m.price <= cap) : pool.slice();
    if (!under.length) under = pool.slice().sort((a, b) => a.price - b.price).slice(0, 1);
    const rank = (list) => list.slice().sort((a, b) => score(b) - score(a) || (cap ? b.price - a.price : a.price - b.price));
    const pick = rank(under)[0];
    const better = cap ? pool.filter((m) => m.price > cap && score(m) > score(pick)).sort((a, b) => score(b) - score(a) || a.price - b.price)[0] || null : null;
    const second = under.filter((m) => m !== pick)
      .sort((a, b) => score(b) - score(a) || Math.abs(a.rung - pick.rung) - Math.abs(b.rung - pick.rung) || a.price - b.price)[0] || null;

    const proofs = C.proofs[pick.key] || {};
    const top = given.map((v, i) => ({ v, i, p: pts(pick, v) })).filter((x) => x.p > 0).sort((a, b) => b.p - a.p || a.i - b.i).slice(0, 2);
    let why;
    if (cap && (better || score(pick) === 0)) {
      why = 'Du ' + fill(C.ui.under, { cap: money(cap) }) + '. ' + (proofs.budget || proofs.default);
    } else if (top.length) {
      const a = C.phrases[top[0].v]; const b = top[1] ? C.phrases[top[1].v] : '';
      why = 'Du ' + a + (b ? (a.indexOf(',') >= 0 ? ', og ' : ' og ') + b : '') + '. ' + (proofs[top[0].v] || proofs.default);
    } else {
      why = proofs.default;
    }
    return { pick, second, why, hint: better ? fill(C.ui.hint, { navn: better.name, pris: better.priceText }) : '', also: second ? pairLine(second, pick, true) : '' };
  }

  /* »Aspire Advanced · 2.000 kr mindre: …« (other compared with base); also = the quiz form »Kig også på …« */
  function pairLine(other, base, also) {
    const d = Math.abs(other.price - base.price);
    const lead = also ? fill(C.ui.also, { navn: other.name }) : other.name;
    const up = other.rung > base.rung;
    const price = d > 0 ? ' · ' + fill(up ? C.ui.more : C.ui.less, { forskel: money(d) }) : '';
    if (Math.abs(other.rung - base.rung) === 1) {
      const txt = up ? (C.steps[other.key] || {}).up : (C.steps[base.key] || {}).down;
      if (txt) return lead + price + ': ' + txt + '.';
    }
    return lead + price + ' · ' + other.rows[0] + '.';
  }

  function bars(done) {
    return el('div.apf-bars', { 'aria-hidden': 'true' }, questions.map((q, i) => el('span' + (i < done ? '.on' : ''))));
  }

  function drawQuestion(focus) {
    const q = questions[step];
    const head = el('h4.hx.apf-q-h', { tabindex: '-1' }, q.text);
    const chips = el('div.apf-chips', { role: 'group', 'aria-label': q.text }, q.options.map((o) =>
      el('button.apf-chip' + (answers[step] === o.v ? '.on' : ''), { type: 'button', 'aria-pressed': String(answers[step] === o.v), 'data-apf-answer': o.v },
        [answers[step] === o.v ? CHECK() : null, o.label])));
    const nav = el('div.apf-nav', null, [
      step > 0 ? el('button.lk.apf-lk', { type: 'button', 'data-apf-back': true }, C.ui.back) : null,
      el('button.lk.apf-lk', { type: 'button', 'data-apf-skip': true }, C.ui.skip),
    ]);
    body.replaceChildren(bars(step), el('div.apf-q', null, [
      el('div', null, [el('p.apf-n', null, fill(C.ui.count, { nr: step + 1, antal: questions.length })), head]),
      el('div', null, [chips, nav]),
    ]));
    if (focus) head.focus({ preventScroll: true });
  }

  function drawResult(focus) {
    result = compute();
    const p = result.pick;
    const name = el('p.apf-name', { tabindex: '-1' }, p.name);
    const isCur = cur && p === cur;
    const act = el('div.apf-act', null, isCur
      ? [el('span.apf-now', null, C.ui.now), canAdd ? el('button.apf-btnd', { type: 'button', 'data-apf-add': true }, C.ui.add) : null]
      : [el('a.apf-btno', { href: p.url }, fill(C.ui.see, { navn: p.name })),
        cur && cmp ? el('a.lk.apf-lk', { href: '#sammenlign', 'data-apf-pair': p.key }, fill(C.ui.compareWith, { navn: cur.name })) : null]);
    act.append(el('button.lk.apf-lk', { type: 'button', 'data-apf-reset': true }, C.ui.restart));
    body.replaceChildren(bars(4), el('div.apf-r', null, [
      el('div.apf-who', null, [
        el('div.apf-th', null, p.img ? el('img', { src: p.img, alt: '', loading: 'lazy' }) : null),
        el('div', null, [el('p.eb.apf-eb', null, C.ui.match), name, el('p.apf-pr.tab', null, p.priceText)]),
      ]),
      el('div.apf-txt', null, [
        el('p.apf-why', null, result.why),
        result.hint ? el('p.apf-sec', null, result.hint) : null,
        result.also ? el('p.apf-sec', null, result.also) : null,
        el('p.apf-trial', null, C.ui.trialLine),
      ]),
      act,
    ]));
    if (focus) name.focus({ preventScroll: true });
  }

  function draw(focus) {
    if (step >= 4) drawResult(focus); else { result = null; drawQuestion(focus); }
    save();
    /* the pair follows the quiz: the pick, or the runner-up when the pick is the page's own machine */
    if (result && cur) { const t = result.pick === cur ? result.second : result.pick; if (t && t !== cur) partner = t; }
    drawCompare();
  }

  host.addEventListener('click', (e) => {
    const t = e.target.closest('button, a');
    if (!t || !host.contains(t)) return;
    if (t.hasAttribute('data-apf-answer')) { answers[step] = t.getAttribute('data-apf-answer'); step += 1; draw(true); }
    else if (t.hasAttribute('data-apf-skip')) { answers[step] = 'skip'; step += 1; draw(true); }
    else if (t.hasAttribute('data-apf-back')) { step = Math.max(0, step - 1); draw(true); }
    else if (t.hasAttribute('data-apf-reset')) { answers = [null, null, null, null]; step = 0; draw(true); }
    else if (t.hasAttribute('data-apf-pair')) { const m = by(t.getAttribute('data-apf-pair')); if (m && m !== cur) { partner = m; drawCompare(); } }
  });

  /* ---------- comparison ---------- */
  let partner = null;
  if (cur) partner = models.filter((m) => m !== cur).sort((a, b) => (a.rung < cur.rung ? 0 : 1) - (b.rung < cur.rung ? 0 : 1) || Math.abs(a.rung - cur.rung) - Math.abs(b.rung - cur.rung))[0];

  function tile(m, cls) { return el('div.' + cls, null, m.img ? el('img', { src: m.img, alt: '', loading: 'lazy' }) : null); }
  function cta(m, cls) {
    if (cur && m === cur) return canAdd ? el('button.apf-btnd' + (cls || ''), { type: 'button', 'data-apf-add': true }, C.ui.add) : el('span');
    return el('a.apf-btno' + (cls || ''), { href: m.url }, fill(C.ui.see, { navn: m.name }));
  }

  function drawCompare() {
    if (!cmp) return;
    const pick = result ? result.pick : null;
    /* four cards (1200 px and wider) */
    const short = (i) => models.every((m) => (m.rows[i] || '').length <= 34);
    const cards = el('div.apk-cards', null, models.map((m) => {
      const lower = models.filter((x) => x.rung < m.rung).pop();
      const d = lower ? m.price - lower.price : 0;
      const tags = [cur && m === cur ? el('span.apf-now', null, C.ui.now) : null, pick === m ? el('span.apf-tag', null, C.ui.match) : null];
      const dl = el('dl');
      C.labels.forEach((lab, i) => { dl.append(el('dt', null, lab), el('dd' + (short(i) ? '.s' : ''), null, m.rows[i] || '–')); });
      return el('article.apk-cc' + (pick === m ? '.pick' : ''), { 'aria-label': m.name }, [
        el('div.apk-tile', null, [m.img ? el('img', { src: m.img, alt: '', loading: 'lazy' }) : null, el('div.apk-tags', null, tags)]),
        el('div.apk-in', null, [
          el('h3.apk-h', null, m.name), el('p.apk-ty', null, m.type),
          el('div.apk-step', null, lower && d > 0 && m.available && lower.available ? el('span.apf-tag.tab', null, fill(C.ui.from, { forskel: money(d), navn: lower.short })) : null),
          el('p.apk-pr.tab', null, m.priceText), el('p.apk-tr', null, el('span.apf-tag', null, C.ui.trial)), dl,
          el('div.apk-cta', null, cta(m, '.w')),
        ]),
      ]);
    }));

    /* two models side by side (below 1200 px) */
    let pair = null;
    if (cur && partner) {
      const others = models.filter((m) => m !== cur);
      const field = el('fieldset.apk-pick', null, [el('legend', null, C.ui.pairLegend), el('div.apf-chips', null, others.map((m) =>
        el('label.apf-chip' + (m === partner ? '.on' : ''), null, [
          el('input.ap-vh', { type: 'radio', name: 'apk-pair', value: m.key, checked: m === partner }), m === partner ? CHECK() : null, m.short])))]);
      const col = (m, isCur) => el('div.apk-col' + (isCur ? '.cur' : ''), null, [
        tile(m, 'apk-ph'), el('p.apk-nm', null, m.name), el('p.apk-p2.tab', null, m.priceText),
        isCur || pick === m ? el('p.apk-tg', null, [isCur ? el('span.apf-now', null, C.ui.now) : null, pick === m ? el('span.apf-tag', null, C.ui.match) : null]) : null,
      ]);
      const same = []; const rows = [];
      C.labels.forEach((lab, i) => {
        if (partner.rows[i] === cur.rows[i]) { same.push(lab); return; }
        rows.push(el('div.apk-row', null, [
          el('p.apk-lab', null, [el('span.apk-dot', { 'aria-hidden': 'true' }), lab, el('span.ap-vh', null, ' · ' + C.ui.diff)]),
          el('div.apk-vals', null, [el('span', null, partner.rows[i] || '–'), el('span', null, cur.rows[i] || '–')]),
        ]));
      });
      pair = el('div.apk-pair', null, [
        field,
        el('div.apk-cols', null, [col(partner, false), col(cur, true)]),
        el('p.apk-line', null, pairLine(partner, cur, false)),
        same.length ? el('p.apk-same', null, fill(C.ui.same, { labels: same.join(', ') })) : null,
        el('div.apk-tbl', null, [el('div.apk-cn', { 'aria-hidden': 'true' }, [el('span', null, partner.short), el('span', null, cur.short)])].concat(rows)),
        el('div.apk-ctas', null, [cta(partner, ''), el('div', null, cta(cur, '.w'))]),
      ]);
    }
    /* the full specification list is the page's own »Specifikationer« drop-down in the top section */
    const spec = cur && document.getElementById('specifikationer')
      ? el('a.apk-spec', { href: '#specifikationer' }, [fill(C.ui.specs, { navn: cur.name }), el('span', { 'aria-hidden': 'true' }, '↑')]) : '';
    const keep = document.activeElement && cmp.contains(document.activeElement) && document.activeElement.name === 'apk-pair';
    cmp.replaceChildren(cards, pair || '', spec);
    if (keep) { const r = cmp.querySelector('input[name="apk-pair"]:checked'); if (r) r.focus({ preventScroll: true }); }
  }

  if (cmp) {
    cmp.addEventListener('click', (e) => {
      const a = e.target.closest('a[href^="#"]');
      const t = a && document.getElementById(a.getAttribute('href').slice(1));
      const det = t && t.closest('details');
      if (det && !det.open) det.open = true;
    });
    cmp.addEventListener('change', (e) => {
      if (e.target.name !== 'apk-pair') return;
      const m = by(e.target.value); if (m) { partner = m; drawCompare(); }
    });
  }

  /* »Tilføj til kurv« in the quiz and the comparison presses the page's own buy form */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-apf-add]');
    if (!b || !canAdd) return;
    if (form.requestSubmit) form.requestSubmit(mainAdd); else mainAdd.click();
  });

  draw(false);
})();
